import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  assignedTaskStore,
  dealStore,
  primaryCustomerStore,
  taskStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { taskStoreV2, taskTemplateStore } from '@/models/stores/tasks-v2.ts';
import { useEffect } from 'react';

const useTasksPageHydrateLocal = () => {
  const isTasksPageActive = isPageActive(PAGE_ROUTES.TASKS);

  useEffect(() => {
    if (!isTasksPageActive) {
      return;
    }

    const hydrateTasks = async () => {
      await Promise.all([
        assignedTaskStore.hydrateLocal(),
        taskStore.hydrateLocal(),
        taskStoreV2.hydrateLocal(),
        taskTemplateStore.hydrateLocal(),
        dealStore.hydrateLocal(),
        userStore.hydrateLocal(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
      ]);
    };

    hydrateTasks();
  }, [isTasksPageActive]);
};

export default useTasksPageHydrateLocal;
